// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { LearningResourceInfo } from './learning-resource-info';

/**
 * 
 * @export
 * @interface AnnexEdit
 */
export interface AnnexEdit {
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    type: AnnexEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    companyId: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof AnnexEdit
     */
    clientType?: string;
    /**
     * **Deprecated.**
     * @type {string}
     * @memberof AnnexEdit
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    contractorId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    agentId?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    conditionId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnnexEdit
     */
    userIds?: Array<string>;
    /**
     * 
     * @type {Array<LearningResourceInfo>}
     * @memberof AnnexEdit
     */
    learningResources?: Array<LearningResourceInfo>;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    paymentConditions: string;
    /**
     * 
     * @type {number}
     * @memberof AnnexEdit
     */
    nds?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnexEdit
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnnexEdit
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AnnexEdit
     */
    signedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AnnexEdit
     */
    formedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum AnnexEditTypeEnum {
    Contract = 'contract',
    Annex = 'annex'
}



